import loadable from '@loadable/component';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Button from '../../../../components/Button/Button';
import useMediaQuery from '../../../../utils/useMediaQuery';
import styles from './ReviewSuccessModal.module.scss';

const Modal = loadable(() => import(/* webpackChunkName: 'Modal'*/ '../../../../components/Modal/Modal'));

const ReviewSuccessModal = ({ isOpen, closeSuccessModal }) => {
  const intl = useIntl();
  const config = useSelector(({ config }) => config);
  const { BREAKPOINTS, isGreaterOrEqualTo } = useMediaQuery();
  const isGreaterThanMedium = isGreaterOrEqualTo(BREAKPOINTS.MEDIUM);
  const isGreaterThanExtraLarge = isGreaterOrEqualTo(BREAKPOINTS.EXTRA_LARGE);

  const getSize = () => {
    if (isGreaterThanMedium) return '200';
    if (isGreaterThanExtraLarge) return '220';

    return '180';
  };
  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeSuccessModal}
      onOverlayClick={closeSuccessModal}
      className={styles.modal}
      title={intl.formatMessage({ id: 'reviewForm.thanks_popup.title', defaultMessage: 'Log in or sign up' })}
    >
      <p>
        <FormattedMessage
          id="reviewForm.thanks_popup.content"
          defaultMessage="Log in or sign up to enjoy many benefits"
          values={{ webShopName: config.websiteName }}
        />
      </p>
      <img src={intl.messages['reviewForm.thanks_popup.image']} alt="" width={getSize()} />
      <footer>
        <Button inverted onClick={closeSuccessModal}>
          <FormattedMessage id="reviewForm.thanks_popup.button" defaultMessage="Close Window" />
        </Button>
      </footer>
    </Modal>
  );
};

export default ReviewSuccessModal;
